export const GOVGR_ERROR_SUMMARY = "govgr-error-summary";
export const GOVGR_HEADING_S = "govgr-heading-s";
export const GOVGR_LINK = "govgr-link";
